import { z } from 'zod';
import { PostType, PostPriority, PostSection } from '../types/post.types';

export const createPostSchema = z.object({
  section: z.nativeEnum(PostSection),
  type: z.nativeEnum(PostType),
  priority: z.nativeEnum(PostPriority).optional().default(PostPriority.NORMAL),
  title: z.string().max(200).optional(),
  content: z.string().max(5000).optional(),
  sourceUrl: z.string().url().optional(),
  showOnHome: z.boolean().optional().default(false),
  sendNotification: z.boolean().optional().default(false),
  zoneIds: z.array(z.string().uuid()).optional().default([]),
  topicIds: z.array(z.string().uuid()).optional().default([]),
  mediaIds: z.array(z.string().uuid()).optional(),
  tagIds: z.array(z.string().uuid()).optional().default([]),
  categoryIds: z.array(z.string().uuid()).optional().default([]),
  newTags: z.array(z.string().max(50)).optional().default([]),
  newCategories: z.array(z.string().max(50)).optional().default([]),
}).refine(
  (data) => {
    if (data.section === PostSection.POSTIME) {
      return !!data.sourceUrl;
    }
    return data.title || data.content || (data.mediaIds && data.mediaIds.length > 0);
  },
  { message: 'Postimi duhet të ketë titull, përmbajtje, media, ose URL burim' }
).refine(
  (data) => {
    if (data.section === PostSection.GALERIA) {
      return data.mediaIds && data.mediaIds.length >= 1;
    }
    return true;
  },
  { message: 'Galeria duhet të ketë të paktën 1 media' }
);

export const updatePostSchema = z.object({
  title: z.string().max(200).optional(),
  content: z.string().max(5000).optional(),
  priority: z.nativeEnum(PostPriority).optional(),
  showOnHome: z.boolean().optional(),
  zoneIds: z.array(z.string().uuid()).optional(),
  topicIds: z.array(z.string().uuid()).optional(),
  tagIds: z.array(z.string().uuid()).optional(),
  categoryIds: z.array(z.string().uuid()).optional(),
});

export const postFiltersSchema = z.object({
  section: z.nativeEnum(PostSection).optional(),
  zone: z.string().optional(),
  topic: z.string().optional(),
  tag: z.string().optional(),
  category: z.string().optional(),
  priority: z.nativeEnum(PostPriority).optional(),
  type: z.nativeEnum(PostType).optional(),
  authorId: z.string().uuid().optional(),
  search: z.string().max(100).optional(),
  page: z.coerce.number().int().positive().optional().default(1),
  limit: z.coerce.number().int().min(1).max(50).optional().default(20),
  sort: z.enum(['latest', 'oldest']).optional().default('latest'),
  startDate: z.coerce.date().optional(),
  endDate: z.coerce.date().optional(),
});

export const linkPreviewSchema = z.object({
  url: z.string().url(),
});

export type CreatePostInput = z.infer<typeof createPostSchema>;
export type UpdatePostInput = z.infer<typeof updatePostSchema>;
export type PostFiltersInput = z.infer<typeof postFiltersSchema>;
export type LinkPreviewInput = z.infer<typeof linkPreviewSchema>;
